import { Container } from '@/common/ui/containers/Container';
import { IBreadcrumbsItem } from '@/shared/Breadcrumbs/domain/Breadcrumbs.domain';
import Layout from '@/shared/Layout/ui/Layout';
import { TLandmarksShort } from '../LandmarkMainPage/domain/Landmarks.domain';
import { TPublicBlogs } from '@/entities/Blogs/domain/Blogs.domain';
import { IState } from '@/common/service/api/Destination/Destination';
import { ShortParagraph } from '../LandmarkDestinationPage/ui/LandmarkDestinationPage.style';
import { useState } from 'react';
import { IRecommendsItem } from '@/shared/FeaturedActivities/ui/featuredActivitiesPreview/FeaturedActivitiesPreview.types';
import Subscribe from '@/shared/Subscribe/ui/Subscribe';
import DestinationTab from './DestinationTab/DestinationTab';
import { useMedia } from '@/common/service/hooks/useMedia';
import { VisitorsGuideBlogs } from '../DestinationsPage/ui/VisitorsGuide/VisitorsGuideBlogs';
import { LandmarksCarousel } from './LandmarksCarousel/LandmarksCarousel';
import { IMeta } from '@/common/domain/Meta.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import { MartkdownHtml } from '@/shared/MarkdownHtml';
import { NewFeaturedActivities } from '@/shared/FeaturedActivities/ui/NewFeaturedActivities';

export interface IStatePageProps {
    meta: IMeta;
    state: IState;
    blogs: TPublicBlogs;
    landmarks: TLandmarksShort;
    breadcrumbs: IBreadcrumbsItem[];
    images: string[];
    recommendedTrips: IRecommendsItem[];
}

const StatePage = ({
    meta,
    state,
    blogs,
    landmarks,
    breadcrumbs,
    images,
    recommendedTrips,
}: IStatePageProps) => {
    const [isViewMore, setIsViewMore] = useState<boolean>(false);
    const isMobileView = useMedia('(max-width: 991px)');
    const destination = Object.values(state.items)[0];
    const item_list_id = typeof window !== 'undefined' ? window.location.pathname : '';

    return (
        <Layout
            breadcrumbs={breadcrumbs}
            TitleName={state.name}
            images={images}
            totalActivities={state.total_activities}
            withMobileHeroImage
        >
            <CommonMeta
                title={meta.title}
                description={meta.description}
                imageSrc={images[0]}
                slug={`/destination/${state.code.toLowerCase()}/`}
                canonical={meta.canonical}
            />
            <Container>
                <ShortParagraph data-test-id="Description" leftAlign markdown>
                    <MartkdownHtml content={state.description} />
                </ShortParagraph>
            </Container>
            <Container>
                <DestinationTab
                    title={`Featured Destinations`}
                    destinations={Object.values(state.items)}
                    isViewMore={isViewMore}
                    setIsViewMore={setIsViewMore}
                    code={state.code}
                />
            </Container>
            <NewFeaturedActivities
                defaultActivities={recommendedTrips || []}
                title={`Featured Activities in ${state.name}`}
                item_list_id={item_list_id}
                item_list_name={`Featured Activities in ${state.name}`}
                placeholders={{}}
            />
            <Subscribe />
            <VisitorsGuideBlogs
                blogs={blogs}
                isMobileView={isMobileView}
                destinationId={state.code}
                title={`${state.name} Travel Blogs`}
                subtitle="Keeping you informed"
                outline
            />
            {!!landmarks.length && (
                <LandmarksCarousel
                    landmarks={landmarks}
                    stateCode={state.code}
                    destinationSlug={destination.slug}
                    destinationName={destination.name}
                    title={`Landmarks in ${state.name}`}
                />
            )}
        </Layout>
    );
};

export default StatePage;
